import script from "./LoanPaymentPopUp.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoanPaymentPopUp.vue?vue&type=script&setup=true&lang=ts"

import "./LoanPaymentPopUp.vue?vue&type=style&index=0&id=6961f5ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6961f5ca"]])

export default __exports__